import { api } from "@/lib/api";
import type { ComparisonResult, MultiEnvKpis, MultiEnvStatus } from "@/lib/types";
import { useQuery } from "@tanstack/react-query";

const POLL_30S = { refetchInterval: 30_000 };

export function useMultiEnvStatus() {
  return useQuery({
    queryKey: ["overview", "multi-status"],
    queryFn: () => api<MultiEnvStatus>("/api/ops/v1/overview/multi-status"),
    ...POLL_30S,
  });
}

export function useMultiEnvKpis() {
  return useQuery({
    queryKey: ["overview", "multi-kpis"],
    queryFn: () => api<MultiEnvKpis>("/api/ops/v1/overview/multi-kpis"),
    ...POLL_30S,
  });
}

export function useDataComparison() {
  return useQuery({
    queryKey: ["data", "comparison"],
    queryFn: () => api<ComparisonResult>("/api/ops/v1/data/comparison"),
    refetchInterval: 300_000, // 5 minutes (cold tier)
  });
}
